import { Skeleton } from "@progress/kendo-react-indicators";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import "./dashboard-skeletons.scss";

export const DashboardGridSkeleton = ({width = '1338px', noShadow = false}) => {
  return (
    <div className={`skeleton-dashboard-container new-dashboard table-wrapper  ${noShadow ? '' : 'task-skeleton-container-shadow'}`}  style={{  width: width, maxWidth: width }}>
      <Grid
        data={Array.from({ length: 7 }).map((_, idx) => ({ id: idx }))}
        style={{ border: "none" }}
        cells={{
          headerCell: HeaderCustomCell,
        }}
        scrollable="none"
      >
        <GridToolbar>
          <div className="task-grid-toolbar ">
            <div className="toolbar-left">
              <div className="toolbar-top-row" data-testid="skeleton-header-left-dashboard">
                <Skeleton
                  shape="rectangle"
                  className="skeleton-searchbar-dashboard"
                  animation={{ type: "wave" }}
                  data-testid="skeleton-searchbar-dashboard"
                />
                <Skeleton
                  shape="rectangle"
                  className="skeleton-dropdown-dashboard"
                  animation={{ type: "wave" }}
                  data-testid="skeleton-button-dashboard"
                />
              </div>
              <div>
                <Skeleton
                  shape="text"
                  className="skeleton-subtitle-dashboard"
                  animation={{ type: "wave" }}
                />
              </div>
            </div>
            <Skeleton
              shape="square"
              className="skeleton-button-dashboard-square"
              animation={{ type: "wave" }}
            />
          </div>
        </GridToolbar>
        <Column
          title=""
          width="50px"
          cell={(cellItem) => {
            const isFirstRow = cellItem.dataIndex === 0;
            return (
              <td className="skeleton-cell" data-testid="text-skeleton-column">
                <Skeleton
                  shape="rectangle"
                  className="skeleton-icon-dashboard"
                  animation={isFirstRow ? { type: "wave" } : { type: "pulse" }}                  
                />
              </td>
            );
          }}
        />
        {Array.from({ length: 8 }).map((_, textIdx) => (
          <Column
            key={textIdx}
            title=""
            cell={(cellItem) => {
              return (
                <td className="skeleton-cell" style={{ border: "none" }}  data-testid="text-skeleton-column">
                  <Skeleton
                    shape="text"
                    className="skeleton-text-dashboard"
                    animation={
                     { type: "pulse" }
                    }
                  />
                </td>
              );
            }}
          />
        ))}
      </Grid>
    </div>
  );
};

export const HeaderCustomCell = (props) => (
  <th className="skeleton-cell headerCustomCell" data-testid={`${props.index !== 0 ? "text-skeleton-column" : ""}`}>
    {props.index !== 0 && (
      <Skeleton
        shape="text"
        className="skeleton-text-dashboard"
        animation={{ type: "wave" }}
        data-testid="text-skeleton"
      />
    )}
  </th>
);